import React, { useState, useEffect } from "react"
import { Link, navigate } from "gatsby"
import API from "../../../api"

const CommonSpec = (props) => {
    let [data, setData] = useState([])
    useEffect(() => {
        API.getCommonSpecs().then(response => {
            if(response){
                setData(response);
            }
        }).catch(err => {
            console.log(err)
        })
    }, [])

    const onClick = (el) => {
        if(props.callBack){
            props.callBack(el) 
        }else{
            if(el?.link && el?.link?.url){
                if(el?.link?.url?.includes('internal:')){
                    const arr = el.link.url.split('internal:')
                    if (arr && arr.length) {
                        navigate(arr[1])
                    }
                }else{
                    navigate(el?.path)
                }
            }
        }
    }

    return (
        <>
        
            <div className={props.className}>
                <div className="speciality_section">
                    <h4 className="top_title">Common Specialities</h4>
                    {data && data.length > 0 && (
                        <ul>
                            {data.map((el, index) => {
                            return (
                                <li key={index}>
                                    <a href="javascript:;" onClick={() => onClick(el)}>{el.name}</a>
                                </li>
                            )
                            })}
                        </ul>
                    )}
                </div>
            </div>
        </>
    )
}
export default CommonSpec